import IconComponent from '../icons';

const Breadcrumb = (props) => {

  if(props.data.length <= 1){
    return <></>;
  }
  
  const renderBreadcrumb = () =>{
    const breadcrumb = props.data;
    let Url = "";
    return breadcrumb?.length && breadcrumb.map((item, index)=>{
      if(index > 0)
      {
        Url = Url + "/" + item.UrlSegment;
      }

      const newsClass = window.location.href.indexOf("/news/") > -1 ? " text-ellipsis overflow-hidden whitespace-nowrap max-w-[50%] lg:block": "";
      const breadcrumbLastItem = breadcrumb.length - 1 === index ?  `font-bold ${newsClass}`: "";
      return (
        <li key={`breadcrumb-${index}`} className={`flex justify-start items-center ${breadcrumbLastItem}`} id={`breadcrumb-${index}`}>
          {breadcrumbLastItem  ? 
            <span>{item.Name}</span> :
            <a href={`${!breadcrumbLastItem && Url}/`}><span>{item.Name}</span></a>
          }
          {breadcrumb.length - 1 !== index && <IconComponent icon='chevron-slim' className='chevron-slim mx-3'/>}
        </li>
      )
    })
  }

  const renderBreadcrumbSkinny = () =>{
    const breadcrumb = props.data;
    let Url = "";
    const breadcrumbFilter = breadcrumb?.length && breadcrumb.slice(0, -1);
    return breadcrumbFilter?.length && breadcrumbFilter.map((item, index)=>{
      if(index > 0)
      {
        Url = Url + "/" + item.UrlSegment;
      }
      if(index + 1 === breadcrumbFilter.length){
        return (
        <li key={`breadcrumb-skinny-${index}`} className={`flex justify-end items-center`} id={`breadcrumb-skinny-${index}`}>
          {breadcrumb.length - 1 !== index && <IconComponent icon='chevron-slim' className='chevron-slim mx-3 relative rotate-180'/>}
          <a href={`${Url}/`}><span>{item.Name}</span></a>
        </li>
      ) 
      }
      else{
        return <></>;
      }
            
    })
  }

  return (
      <div className='relative grid grid-cols-12 justify-start text-white h-[24px] lg:h-[32px] items-center'>
        <div className='col-span-12 lg:col-span-1 hidden lg:flex'></div>
        <div className='col-span-8 hidden lg:flex justify-start relative ml-6 xl:ml-5'>
            <ul className='flex justify-start items-center relative text-xs'>
              {renderBreadcrumb()}
            </ul>
        </div>
        <div className='col-span-12 lg:hidden justify-start relative pl-16 -ml-3 lg:ml-0'>
            <ul className='flex justify-start items-center relative text-xs'>
              {renderBreadcrumbSkinny()}
            </ul>
        </div>
      </div>
  )

}


export default Breadcrumb;